import { connect } from 'react-redux';

import { GET_PLACE_DETAIL, UPDATE_PLACE } from 'store/place/actionTypes';
import { GET_DISTRICT_LIST, GET_PROVINCE_LIST, GET_WARD_LIST } from 'store/address/actionTypes';
import { GET_BOOKING_REVIEW_LIST } from 'store/booking-review/actionTypes';
import { UPDATE_PLACE_OTA_CREDENTIALS } from 'store/update-place-ota-credentials/actionTypes';

import { actionDeleteLocation } from 'store/location/actions';
import Location from './Location';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingUpdatePlace: state.Place.isLoadingUpdatePlace,
  isLoadingUpdatePlaceOtaCredentials:
    state.UpdatePlaceOtaCredentials.isLoadingUpdatePlaceOtaCredentials,
  placeDetail: state.Place.placeDetail,

  bookingReviewList: state.BookingReview.bookingReviewList,
  provinces: state.Address.provinces,
  districts: state.Address.districts,
  wards: state.Address.wards,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionUpdatePlace: (payload) => dispatch({
    type: UPDATE_PLACE,
    payload,
  }),

  actionUpdatePlaceOtaCredentials: (payload) => dispatch({
    type: UPDATE_PLACE_OTA_CREDENTIALS,
    payload,
  }),

  actionDeleteLocation: (payload) => dispatch(actionDeleteLocation(payload)),

  actionGetProvinceList: (payload) => dispatch({
    payload,
    type: GET_PROVINCE_LIST,
  }),

  actionGetDistrictList: (payload) => dispatch({
    payload,
    type: GET_DISTRICT_LIST,
  }),

  actionGetWardList: (payload) => dispatch({
    payload,
    type: GET_WARD_LIST,
  }),

  actionGetBookingReviewList: (payload) => dispatch({
    payload,
    type: GET_BOOKING_REVIEW_LIST,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Location);
